import PropTypes from 'prop-types';
import React, { useState, useEffect, useMemo } from "react";
import FeatherIcon from 'feather-icons-react';
import { useSelector, useDispatch } from 'react-redux';
import { Collapse, Typography, Divider, message, Row, Col, Spin } from "antd";
import { DownOutlined, UpOutlined } from "@ant-design/icons";
import AccountIntePage from './AccountIntePage'
import { setChatCall } from '../../../../redux/CrmReduxCalls/EditNavCtrl';
import { FetchUserDetails } from "../../../../Api/Services/UserApiService"
import { FetchAccountDetails } from "../../../../Api/Services/AccountApiService"
import { FetchContactDetails } from "../../../../Api/Services/ContactApiService"
import { fetchDomainAvaliability, extractDomain } from "../../../../Api/Services/CompanyApiService"
import { AccountsIcon, StaffIcon, ReportsIcon, ScoreIcon } from '../../../../components/Icons/Icons';
import Meeting from '../../TablesAndTimelines/MeetingTable'
import Scoring from "../../TablesAndTimelines/ScoringGrapg"
import { RelatedDocs } from '../GlobalComponents/RelatedDocUpload'
import { UserSideDiv } from '../GlobalComponents/UserCardCmnts';
import { contactInsights } from '../../../../Api/Services/CommonApiService';

const { Panel } = Collapse;
const { Text } = Typography;

const NoteDetails = ({ displayData, profile, ViewDetailPage, UrlId, NacTrigger, setNaCTrigger, trigger }) => {
    const dispatch = useDispatch()
    const localData = useSelector((state) => state.localRedux);
    const Role = localData.role
    const companyProfile = localData.company
    const [report, setReport] = useState()
    const [userData, setUserData] = useState()
    const [contactData, setContactData] = useState()
    const [accountData, setAccountData] = useState()
    const [isOpen4, setIsOpen4] = useState(false);
    const [isOpen5, setIsOpen5] = useState(false);
    const [isOpen, setIsOpen] = useState(false);
    const [isOpen2, setIsOpen2] = useState(true);
    const [isOpen3, setIsOpen3] = useState(true);
    const [openIntelligence, setOpenIntelligence] = useState(false);

    async function getAccountReports(params) {
        try {
            const ValidDomain = await extractDomain(params)
            if (ValidDomain) {
                const Response = await fetchDomainAvaliability(ValidDomain)
                if (Response === "") {
                    setReport({ allow: false, data: null })
                }
                else {
                    setReport({ allow: true, data: Response })
                }
            }
        } catch (error) {
            message.error(error)
        }
    }
    async function getUsersData(params) {
        try {
            const Response = await FetchUserDetails(params)
            setUserData(Response?.data)
        } catch (error) {
            message.error(error)
        }
    }
    async function getAccountData(params) {
        try {
            const responseData = await FetchAccountDetails(params)
            const Response = responseData.data
            const merged = { ...Response, DataPermission: { isPresent: responseData.allow }, };
            setAccountData(merged)
            if (merged?.website) {
                getAccountReports(merged?.website)
            } else {
                setReport({ allow: false, data: null })
            }
        } catch (error) {
            message.error(error)
        }
    }
    async function getContactData(params) {
        try {
            const responseData = await FetchContactDetails(params)
            const Response = responseData.data
            const merged = { ...Response, DataPermission: { isPresent: responseData.allow }, };
            setContactData(merged)
        } catch (error) {
            message.error(error)
        }
    }
    const handleExpand5 = (key) => {
        setIsOpen5(key.length > 0);
    };
    const handleExpand4 = (key) => {
        setIsOpen4(key.length > 0);
    };
    const handleExpand = (key) => {
        setIsOpen(key.length > 0);
    };
    const handleExpand2 = (key) => {
        setIsOpen2(key.length > 0);
    };
    const handleExpand3 = (key) => {
        setIsOpen3(key.length > 0);
    };
    useEffect(() => {
        if (isOpen4) {
            if (displayData?.leadOwner) {
                getUsersData(displayData?.leadOwner)
            } else {
                setUserData()
            }
        }
    }, [displayData?.leadOwner, isOpen4])
    useEffect(() => {
        if (isOpen2) {
            if (displayData?.accountId) {
                getAccountData(displayData?.accountId)
            } else {
                setAccountData()
            }
        }
    }, [displayData?.accountId, isOpen2])
    useEffect(() => {
        if (isOpen5) {
            if (displayData?.reportingTo) {
                getContactData(displayData?.reportingTo)
            } else {
                setContactData()
            }
        }
    }, [displayData?.reportingTo, isOpen5])
    const openTacking = () => {
        setOpenIntelligence(!openIntelligence)
    }
    const memoUrlId = useMemo(
        () => UrlId,
        [UrlId?.[0], UrlId?.[1]]
    );
    const openScoreGeniee = async () => {
        let hideMessage;
        try {
            hideMessage = message.loading("Gathering insights...", 0);
            const response = await contactInsights(companyProfile.companyCode, memoUrlId[1])
            if (response.status === 200 && response.statusText === "OK") {
                hideMessage();
                dispatch(setChatCall(true));
            }
        }
        catch (error) {
            hideMessage();
            message.error(error)
        }
    }
    return (
        <>
            <Collapse className="DetailsTabCollapse2" defaultActiveKey={["1"]} bordered={false} onChange={handleExpand3} expandIcon={({ isActive }) => isActive ? <UpOutlined /> : <DownOutlined />} expandIconPosition="end">
                <Panel header={<div style={{ display: "flex", justifyContent: "space-between", width: "100%", alignItems: "center" }}> <div
                    style={{
                        display: "flex",
                        alignItems: "center",
                        gap: 10,
                        minWidth: 0,
                    }}
                >
                    <Text
                        strong
                        style={{
                            fontSize: 14,
                            whiteSpace: "nowrap",
                            flexShrink: 0,
                        }}
                    >
                        Contact Score
                    </Text>
                    <div className='Hover-Refresh3 back-hover2 able-style'
                        role="button"
                        tabIndex={0} title='View Score Insights'
                        onClick={(e) => {
                            e.stopPropagation();   // ✅ IMPORTANT
                            openScoreGeniee();
                        }}
                        onKeyDown={(event) => {
                            if (event.key === 'Enter' || event.key === ' ') {
                                event.stopPropagation();
                                openScoreGeniee()
                            }
                        }}
                        aria-label='insights'
                    ><ScoreIcon height={20} width={20} /></div>
                </div><Text type="secondary" style={{ marginRight: "12%", fontSize: 12 }}>{isOpen3 ? "Close" : "View"}</Text></div>} key="1">
                    <div className='RightSide-DataShadow' style={{ padding: "30px 10px" }}>
                        <Scoring UrlId={memoUrlId} NacTrigger={NacTrigger} trigger={trigger} />
                    </div>
                </Panel>
            </Collapse>
            <Divider style={{ margin: "10px 0" }} />
            <Meeting UrlId={memoUrlId} NacTrigger={NacTrigger} setNaCTrigger={setNaCTrigger} profile={profile} type="List" />
            {(displayData?.accountId && accountData) && <>
                <Divider style={{ margin: "10px 0" }} />
                <Collapse className="DetailsTabCollapse2" defaultActiveKey={["1"]} bordered={false} onChange={handleExpand2} expandIcon={({ isActive }) => isActive ? <UpOutlined /> : <DownOutlined />} expandIconPosition="end">
                    <Panel header={
                        <div style={{ display: "flex", justifyContent: "space-between", width: "100%", alignItems: "center" }}>
                            <div
                                style={{
                                    display: "flex",
                                    alignItems: "center",
                                    gap: 10,
                                    minWidth: 0,
                                }}
                            >
                                <Text
                                    strong
                                    style={{
                                        fontSize: 14,
                                        whiteSpace: "nowrap",
                                        flexShrink: 0,
                                    }}
                                >
                                    Account
                                </Text>

                                {isOpen2 ? <div className={!report?.allow ? "disabled-style" : 'Hover-Refresh3 back-hover2 able-style'}
                                    role="button"
                                    tabIndex={0} title='View Account Intelligence Report'
                                    onClick={!report?.allow ? undefined : () => openTacking()}
                                    onKeyDown={(event) => {
                                        if (report?.allow && (event.key === 'Enter' || event.key === ' ')) {
                                            openTacking()
                                        }
                                    }}
                                    aria-label='report'
                                ><ReportsIcon height={20} width={20} /></div> : <></>}
                            </div>
                            <Text type="secondary" style={{ marginRight: "12%", fontSize: 12 }}>{isOpen2 ? "Close" : "View"}</Text></div>} key="1">
                        {accountData ? <div className='RightSide-DataShadow'>
                            <div className={`user-info_image ${accountData?.DataPermission?.isPresent && "ListNavigate"}`}
                                style={{ padding: "0px 0px 10px", display: "flex", alignItems: "center", minWidth: 0, }} tabIndex={0} role="button"
                                onClick={accountData?.DataPermission?.isPresent ? () => accountData?.accountId && ViewDetailPage(accountData?.accountId, "ACCOUNT") : undefined}
                                onKeyDown={(event) => {
                                    if (event.key === 'Enter' || event.key === ' ') {
                                        ViewDetailPage(accountData?.accountId, "ACCOUNT")
                                    }
                                }}
                            >
                                {accountData?.accountProfile !== null && accountData?.accountProfile
                                    !== undefined && accountData?.accountProfile !== "" ?
                                    <figure>
                                        <img style={{ width: "30px", height: "30px", objectFit: "cover", flexShrink: 0 }} src={accountData?.accountProfile} alt="" />
                                    </figure>
                                    :
                                    <span className='list_span_Tag AccountIcon' style={{ flexShrink: 0, }}>
                                        {accountData?.accountName?.slice(0, 1).toUpperCase()}
                                    </span>
                                }
                                <figcaption style={{
                                    display: "flex",
                                    flexDirection: "column",
                                    overflow: "hidden", // 👈 keeps ellipsis responsive
                                }}>
                                    <div style={{
                                        overflow: "hidden",
                                        textOverflow: "ellipsis",
                                        whiteSpace: "nowrap",
                                    }} title={accountData?.accountName}>{accountData?.accountName}</div>
                                    <div style={{
                                        fontSize: 12, color: "#adb4d2", overflow: "hidden",
                                        textOverflow: "ellipsis",
                                        whiteSpace: "nowrap",
                                    }} title={accountData?.accountNumber}>{accountData?.accountNumber}</div>
                                </figcaption>
                            </div>
                            <Row gutter={30}>
                                <Col xs={24} sm={24} md={24} lg={12} xl={12} xxl={12}>
                                    {(accountData?.industryName && accountData?.industryName !== "") ?
                                        <div className='Right-side-divs'><Text type="secondary" className='RightSide-Lable'>Industry</Text>
                                            <br />
                                            <Text >{accountData?.industryName}</Text>
                                        </div> : <></>}</Col>
                                <Col xs={24} sm={24} md={24} lg={12} xl={12} xxl={12}>
                                    {(accountData?.nomOfEmployees && accountData?.nomOfEmployees !== "") ?
                                        <div className='Right-side-divs'><Text type="secondary" className='RightSide-Lable'>No of Employees</Text>
                                            <br />
                                            <Text >{accountData?.nomOfEmployees}</Text>
                                        </div> : <></>}
                                </Col>
                            </Row>
                            <Row gutter={30}>
                                <Col xs={24} sm={24} md={24} lg={12} xl={12} xxl={12}>
                                    {(accountData?.annualRevenue && accountData?.annualRevenue !== "") ?
                                        <div className='Right-side-divs'><Text type="secondary" className='RightSide-Lable'>Annual Revenue</Text> <br />
                                            <Text >{accountData?.annualRevenue}</Text>
                                        </div> : <></>}</Col>
                                <Col xs={24} sm={24} md={24} lg={12} xl={12} xxl={12}>
                                    {(accountData?.rating && accountData?.rating !== "") ?
                                        <div><Text type="secondary" className='RightSide-Lable'>Rating</Text> <br />
                                            <Text >{accountData?.rating}</Text>
                                        </div> : <></>}
                                </Col>
                            </Row>
                            {accountData?.accountOwner &&
                                <div><Text type="secondary" className='RightSide-Lable'>Account Owner</Text> <br />
                                    <Text >
                                        <div className={`user-info_image ${(Role === "Administrator" || profile.userId === accountData?.accountOwner) && "ListNavigate"}`}
                                            role="button" style={{ padding: "5px 0px 0px", display: "flex", alignItems: "center", minWidth: 0, }}
                                            tabIndex={0}
                                            onClick={(Role === "Administrator" || profile.userId === accountData?.accountOwner) ? () => accountData?.accountOwner && ViewDetailPage(accountData?.accountOwner, "USER") : undefined}
                                            onKeyDown={(event) => {
                                                if (event.key === 'Enter' || event.key === ' ') {
                                                    ViewDetailPage(accountData?.accountOwner, "USER");
                                                }
                                            }}> {accountData?.userProfilePic !== null && accountData?.userProfilePic
                                                !== undefined && accountData?.userProfilePic !== "" ?
                                                <figure>
                                                    <img style={{ width: "30px", height: "30px", objectFit: "cover", flexShrink: 0 }} src={accountData?.userProfilePic} alt="" />
                                                </figure>
                                                :
                                                <span className='list_span_Tag UserIcon' style={{ flexShrink: 0, }}>
                                                    {accountData?.userFirstName?.slice(0, 1).toUpperCase()}
                                                </span>
                                            }
                                            <figcaption style={{
                                                display: "flex",
                                                flexDirection: "column",
                                                overflow: "hidden", // 👈 keeps ellipsis responsive
                                            }}>
                                                <div style={{
                                                    overflow: "hidden",
                                                    textOverflow: "ellipsis",
                                                    whiteSpace: "nowrap",
                                                }} title={`${accountData?.userFirstName} ${accountData?.userLastName}`}> {`${accountData?.userFirstName} ${accountData?.userLastName}`}</div>
                                                <div style={{
                                                    fontSize: 12, color: "#adb4d2", overflow: "hidden",
                                                    textOverflow: "ellipsis",
                                                    whiteSpace: "nowrap",
                                                }} title={accountData?.accountOwnerEmail}>{accountData?.accountOwnerEmail}</div>
                                            </figcaption>
                                        </div>
                                    </Text>
                                </div>
                            }
                        </div> : <div className='RightSide-DataShadow'>
                            <div style={{
                                display: "flex",
                                alignItems: "center",
                                justifyContent: "center",
                                height: "10rem"
                            }}>
                                <Spin />
                            </div>
                        </div>}
                    </Panel>
                </Collapse></>}
            {displayData?.reportingTo ?
                <><Divider style={{ margin: "10px 0" }} />
                    <Collapse className="DetailsTabCollapse2" bordered={false} onChange={handleExpand5} expandIcon={({ isActive }) => isActive ? <UpOutlined /> : <DownOutlined />} expandIconPosition="end"            >
                        <Panel header={<div style={{ display: "flex", justifyContent: "space-between", width: "100%", alignItems: "center" }}><Text strong>Reporting To</Text><Text type="secondary" style={{ marginRight: "12%", fontSize: 12 }}>{isOpen5 ? "Close" : "View"}</Text></div>} key="1">
                            {contactData ? <div className='RightSide-DataShadow'>
                                <div className={`user-info_image ${contactData?.DataPermission?.isPresent && "ListNavigate"}`}
                                    role="button" style={{ padding: "0px 0px 10px", display: "flex", alignItems: "center", minWidth: 0, }}
                                    tabIndex={0}
                                    onClick={contactData?.DataPermission?.isPresent ? () => contactData?.contactsId && ViewDetailPage(contactData?.contactsId, "CONTACT") : undefined}
                                    onKeyDown={(event) => {
                                        if (event.key === 'Enter' || event.key === ' ') {
                                            ViewDetailPage(contactData?.contactsId, "CONTACT")
                                        }
                                    }}
                                >  {contactData?.contactProfile !== null && contactData?.contactProfile
                                    !== undefined && contactData?.contactProfile !== "" ?
                                    <figure>
                                        <img style={{ width: "30px", height: "30px", objectFit: "cover", flexShrink: 0 }} src={contactData?.contactProfile} alt="" />
                                    </figure>
                                    :
                                    <span className='list_span_Tag ContactIcon' style={{ flexShrink: 0, }}>
                                        {contactData?.firstName?.slice(0, 1).toUpperCase()}
                                    </span>
                                    }
                                    <figcaption style={{
                                        display: "flex",
                                        flexDirection: "column",
                                        overflow: "hidden", // 👈 keeps ellipsis responsive
                                    }}>
                                        <div title={`${contactData?.firstName} ${contactData?.lastName}`}
                                            style={{
                                                overflow: "hidden",
                                                textOverflow: "ellipsis",
                                                whiteSpace: "nowrap",
                                            }}> {`${contactData?.firstName} ${contactData?.lastName}`}</div>
                                        <div style={{
                                            fontSize: 12, color: "#adb4d2", overflow: "hidden",
                                            textOverflow: "ellipsis",
                                            whiteSpace: "nowrap",
                                        }} title={contactData?.email}>{contactData?.email}</div>
                                    </figcaption>
                                </div>
                                {(contactData?.designation && contactData?.designation !== "") &&
                                    <div style={{ marginBottom: 10, display: "flex", alignItems: "center" }}>
                                        <StaffIcon height={15} width={15} marginRight={5} />{contactData?.designation}
                                    </div>}
                                {(contactData?.mobile && contactData?.mobile !== "") &&
                                    <div style={{ marginBottom: 10, display: "flex", alignItems: "center" }}>
                                        <FeatherIcon icon="phone" size={15} style={{ display: "flex", alignItems: "center", marginRight: 5 }} />{contactData?.mobile}
                                    </div>}
                                {contactData?.accountId &&
                                    <div style={{ marginBottom: 10, display: "flex", alignItems: "center" }}>
                                        <AccountsIcon height={15} width={15} marginRight={5} />{contactData?.accountName}
                                    </div>}
                            </div> : <div className='RightSide-DataShadow'>
                                <div style={{
                                    display: "flex",
                                    alignItems: "center",
                                    justifyContent: "center",
                                    height: "10rem"
                                }}>
                                    <Spin />
                                </div>
                            </div>}
                        </Panel>
                    </Collapse ></> : <></>}
            <Divider style={{ margin: "10px 0" }} />
            <Collapse className="DetailsTabCollapse2" bordered={false} onChange={handleExpand4} expandIcon={({ isActive }) => isActive ? <UpOutlined /> : <DownOutlined />} expandIconPosition="end"            >
                <Panel header={<div style={{ display: "flex", justifyContent: "space-between", width: "100%", alignItems: "center" }}><Text strong>Contact Owner</Text><Text type="secondary" style={{ marginRight: "12%", fontSize: 12 }}>{isOpen4 ? "Close" : "View"}</Text></div>} key="1">
                    <UserSideDiv userData={userData} />
                </Panel>
            </Collapse >
            <Divider style={{ margin: "10px 0" }} />
            <Collapse className="DetailsTabCollapse2" bordered={false} onChange={handleExpand} expandIcon={({ isActive }) => isActive ? <UpOutlined /> : <DownOutlined />} expandIconPosition="end"            >
                <Panel header={<div style={{ display: "flex", justifyContent: "space-between", width: "100%", alignItems: "center", }}><div style={{ fontWeight: 600 }}>Documents<span style={{ background: "#f0f0f0", borderRadius: "50%", padding: "2px 6px", fontSize: "12px", fontWeight: 500, marginLeft: "10px", }}>{displayData?.contactFiles?.length || 0}</span></div><Text type="secondary" style={{ marginRight: "12%", fontSize: 12 }}>{isOpen ? "Close" : "View"}</Text></div>} key="1">
                    {displayData?.contactFiles?.map((file, index) => (
                        <RelatedDocs file={file} index={index} />
                    ))}
                </Panel>
            </Collapse>
            <Divider style={{ margin: "10px 0" }} />
            <AccountIntePage openIntelligence={openIntelligence} openTacking={openTacking} researchContent={report?.data} />
        </>
    );
};
NoteDetails.propTypes = {
    displayData: PropTypes.object.isRequired,
    profile: PropTypes.object.isRequired,
    ViewDetailPage: PropTypes.func.isRequired,
    // Role: PropTypes.string.isRequired,
    UrlId: PropTypes.array.isRequired,
    NacTrigger: PropTypes.string.isRequired,
    trigger: PropTypes.string.isRequired,
    setNaCTrigger: PropTypes.func.isRequired,
};
export default NoteDetails;
